/**
 * Tiny pub/sub so the navbar's EnvironmentalDataWidget can refetch immediately
 * after Manage > Environmental Data saves a new value, without polling or
 * prop-drilling across the layout boundary (Topbar is a sibling of the routed
 * page content, not a parent/child).
 */
type Listener = () => void;

const listeners = new Set<Listener>();

export const subscribeToEnvironmentalDataUpdates = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const notifyEnvironmentalDataUpdated = (): void => {
  listeners.forEach((listener) => listener());
};
